<template>
    <div>
        <h2>Relatório de Fornecedores</h2>
        <div class="d-flex w-100">

            <div class="text-center mt-5 mb-5">
                <v-menu class="mr-5">
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" v-on="on" large>
                            Gerar Relatorio
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item v-for="(item, index) in actions" :key="index" :value="index" @click="item.handle"
                            class="cursor-pointer">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>

                </v-menu>

                <v-btn class="ml-5" @click="openDialogFilter = true" large color="primary" outlined>
                    Filtro
                    <v-icon>mdi-filter</v-icon>
                </v-btn>

            </div>

        </div>

        <template>
            <div class="tabela">
                <div class="linha header">
                    <div class="cel codigo">CÓD.</div>
                    <div class="cel contato">CONTATO</div>
                    <div class="cel">DEPTO</div>
                    <div class="cel telefone">TELEFONE</div>
                    <div class="cel ramal">RAMAL</div>
                    <div class="cel celular">CELULAR</div>
                </div>

                <!-- Renderizando cada grupo de cliente -->
                <div v-for="cliente in dadosTabela" :key="cliente._id">
                    <!-- Linha do cliente -->
                    <div class="linha cliente">
                        <div class="cel codigo">{{ cliente.codigo }}</div>
                        <div class="cel contato">{{ cliente.nomeFantasia }}</div>
                        <!-- <div class="cel depto">{{ cliente.razaoSocial }}</div> -->
                        <div class="cel telefone"></div>
                        <div class="cel ramal"></div>
                        <div class="cel celular"></div>
                    </div>

                    <!-- Detalhes do cliente -->
                    <div class="linha detalhe" v-for="(detalhe, index) in cliente.contatos"
                        :key="`${cliente._id}-${index}`">
                        <div class="cel codigo"></div>
                        <div class="cel contato">{{ detalhe.nome }}</div>
                        <div class="cel">{{ detalhe.departamento }}</div>
                        <div class="cel telefone">{{ detalhe.telefone }}</div>
                        <div class="cel ramal">{{ detalhe.ramal }}</div>
                        <div class="cel celular">{{ detalhe.celular }}</div>
                    </div>
                    
                    <div
                        v-for="(material) in cliente.materiais"
                        :key="material._id"
                        class="linha subdetalhe"
                    >
                    
                    <div class="cel codigo">
                        <strong>Material Fornecido:</strong>
                    </div>
                        <div class="cel contato">↳ {{ material.materialFornecedorDescricao }}</div>
                    </div>

                </div>

            </div>
        </template>

        <modal-filter-view 
            :open="openDialogFilter"
            @close="openDialogFilter = false"
            @filter-applied="aplicateFilter"
        ></modal-filter-view>

        <relatorio-fornecedor-preview
            :isOpen="openPreview"
            :dados-tabela="dadosTabela"
            :filters="filter"
            @exportPdf="gerarPDF"
            @cancel="openPreview = false"
        />
    </div>
</template>

<script>

import Vue from 'vue';
import * as XLSX from 'xlsx'
import moment from 'moment'
import html2pdf from 'html2pdf.js'
import ModalFilterView from './ModalFilterView.vue';
import RelatorioFornecedorPreview from './RelatorioFornecedorPreview.vue';

export default {
  components: { ModalFilterView, RelatorioFornecedorPreview },
    name: 'RelatorioFornecedor',
    data(){
        return {
            openPreview: false,
            openDialogFilter: false,
            dadosTabela: [],
            filter: {
                dataInicio: null,
                dataFim: null,
                codigo: null,
                idFornecedor: null,
                order: null,
                filterdescricaoMaterial: null
            },
            actions: [
                {
                    title: "Gerar XLS",
                    handle: () => {
                        this.exportToExcel()
                    }
                },
                {
                    title: "Gerar PDF",
                    handle: () => {
                        this.openPreview = true
                    }
                }
            ],
        }
    },

    methods: {
        async getRelatorioFornecedores(){
            const response = await Vue.prototype.$http.post('/View/run', {
                    params: [
                        { dataType: "String", name: "nomeFantasia", value: this.filter.idFornecedor || '' },
                        { dataType: "String", name: "dataInicio", value: this.filter.dataInicio ? moment(this.filter.dataInicio).format('YYYY-MM-DD') : moment('1970-01-01').format('YYYY-MM-DD') },
                        { dataType: "String", name: "dataFim", value: this.filter.dataFim ? moment(this.filter.dataFim).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD') },
                        { dataType: "String", name: "descricaoMaterial", value: this.filter.filterdescricaoMaterial || '' },
                        { dataType: "string", name: "order", value: "nomeFantasia" },
                        { dataType: "Number", name: "desc", value: this.filter.order ? Number(this.filter.order) : 1 }
                    ],
                    viewId: "e37736b7-c976-427f-87f6-090ff97f826d",
                    page: 1,
                    limit: 3000000

            })
            this.dadosTabela = response.data.data.data            
        },

        aplicateFilter(filter){
            this.filter.idFornecedor = filter.fornecedorId
            this.filter.filterdescricaoMaterial = filter.filterdescricaoMaterial
            this.filter.order = filter.order

            this.getRelatorioFornecedores()
            this.openDialogFilter = false
        },

        exportToExcel(){

            const dadosPlanilha = [];

            this.dadosTabela.forEach((cliente) => {
                // Linha principal
                dadosPlanilha.push({
                    CÓDIGO: cliente.codigo,
                    CONTATO: cliente.nomeFantasia,
                    //DEPTO: cliente.razaoSocial,
                    TELEFONE: "",
                    RAMAL: "",
                    CELULAR: "",
                });

                // Detalhes
                cliente.contatos.forEach((detalhe) => {
                    dadosPlanilha.push({
                        CÓDIGO: "",
                        CONTATO: detalhe.nome,
                        DEPTO: detalhe.departamento,
                        TELEFONE: detalhe.telefone,
                        RAMAL: detalhe.ramal,
                        CELULAR: detalhe.celular,
                    });
                });
            });

            // Criar planilha e salvar
            const worksheet = XLSX.utils.json_to_sheet(dadosPlanilha);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Contatos");

            // Salvar
            XLSX.writeFile(workbook, "tabela-contatos.xlsx");
        },

        gerarPDF() {
            const elemento = document.getElementById("conteudoPDF");
            html2pdf()
            .set({
                margin: 10,
                filename: 'Relatorio-Fornecedor.pdf',
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
            })
            .from(elemento)
            .save();
        }
    },

    async created(){
        await this.getRelatorioFornecedores()
    }
}
</script>

<style scoped>
.tabela {
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  font-family: sans-serif;
  font-size: 14px;
  width: 100%;
}

.linha {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 2fr 1fr 1fr; /* 6 colunas */
  border-bottom: 1px solid #ddd;
}

.header {
  background-color: #eee;
  font-weight: bold;
}

.cliente {
  background-color: #dce6f1;
  font-weight: bold;
}

.detalhe {
  background-color: #fff;
}

/* 🔹 Subtabela */
.subdetalhe {
  background-color: #f9f9f9;
  font-size: 13px;
  padding-left: 20px;
}

.cel {
  padding: 6px 10px;
  border-right: 1px solid #e0e0e0;
}

.cel:last-child {
  border-right: none;
}
</style>